import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const DISPATCHERS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('DISPATCHERS');
export const DISPATCHERS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	DISPATCHERS_CRUD_ACTION_CONSTANTS
);
